<div class="modal-header">
  <h4 class="modal-title d-flex justify-content-center">
    @if (logoUrl) {
      <img
        [src]="logoUrl"
        alt="Logo"
        class="brand-logo"
        style="max-height: 40px; max-width: 220px; object-fit: contain"
      />
    }
  </h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12 float-left">
      <b>{{ '::ProductVersion' | abpLocalization }}:</b>
      <span>
        @if (loading) {
          <i class="fa-solid fa-spinner fa-pulse fa-fw ms-1"></i>
        }
        {{ productVersion }}
      </span>
    </div>
  </div>

  <br />

  <p (click)="toggleDetails()" style="text-decoration: underline; cursor: pointer">
    {{ (isDetailsVisible ? '::HideDetails' : '::ShowDetails') | abpLocalization }}
  </p>

  @if (isDetailsVisible) {
    <div>
      @for (pod of serviceVersionsDto?.appSetDto?.pods; track pod) {
        <div class="row">
          <div class="col-md-12 float-left">
            <b>{{ pod?.app }}:</b> {{ pod?.tag }}
          </div>
        </div>
      }
      <br />
      <div class="row">
        <div class="col-md-12 float-left">
          <b>{{ '::MLProvider' | abpLocalization }}:</b>
          {{ serviceVersionsDto?.nluProviderDto?.nluProvider }}
        </div>
        @if (serviceVersionsDto?.nluProviderDto?.nluClientBaseAddress !== '') {
          <div class="col-md-12 float-left">
            <b>{{ '::MLUrl' | abpLocalization }}:</b>
            {{ serviceVersionsDto?.nluProviderDto?.nluClientBaseAddress }}
          </div>
        }
        @if (serviceVersionsDto?.nluProviderDto?.aiModuleVersions?.length) {
          <br /><br />
          <div class="col-md-12 float-left">
            @for (module of serviceVersionsDto?.nluProviderDto?.aiModuleVersions; track module) {
              <div>
                <b>{{ module?.name }}:</b> v{{ module?.version }}
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="closeModal()">
    {{ 'AbpUi::Close' | abpLocalization }}
  </button>
</div>
